"use client";
import { pubsub } from "utils";
import { pubSubKeyMap } from "@/src/utils/pubSubKeyMap";

/**
 * iframe 端：用于与插件通信
 * - 监听插件消息，收到 window.open 指令后回传 action 给插件
 */
export type ExtensionToIframeCommonHandlers = {
  themeChange: (theme: "dark" | "light") => void;
};

export class IframeToExtension {
  static EXT_TO_IFRAME_KEY = "__EXTENSION_TO_IFRAME__WINDOW_OPEN__";
  static EXT_TO_IFRAME_NAVIGATE_TO_KEY = "__EXTENSION_TO_IFRAME__NAVIGATE_TO__";
  static IFRAME_TO_EXT_KEY = "__IFRAME_TO_EXTENSION__WINDOW_OPEN__";
  static EXT_TO_IFRAME_THEME_COMMON_KEY =
    "__EXTENSION_TO_IFRAME__THEME_COMMON__KEY__";
  static EXT_TO_IFRAME_LOGIN_KEY = "__EXTENSION_TO_IFRAME__LOGIN__KEY__";
  static IFRAME_TO_EXT_LOGIN_KEY = "__IFRAME_TO_EXTENSION__LOGIN__KEY__";

  windowId?: string;
  navigateTo?: (path: string) => void;
  static instance: IframeToExtension;
  commomHandlers?: ExtensionToIframeCommonHandlers;

  static getInstance() {
    if (!this.instance) {
      this.instance = new IframeToExtension();
    }
    return this.instance;
  }

  init(
    windowId: string,
    navigateTo: (path: string) => void,
    commomHandlers?: ExtensionToIframeCommonHandlers,
  ) {
    this.windowId = windowId;
    this.navigateTo = navigateTo;
    this.commomHandlers = commomHandlers;
  }

  openExtensionWindow(url: string) {
    if (!this.windowId) {
      return false;
    }
    window.parent.postMessage(
      {
        key: IframeToExtension.IFRAME_TO_EXT_KEY,
        payload: { url: url },
        windowId: this.windowId,
      },
      "*",
    );
    return true;
  }

  /**
   * 监听插件消息，收到 window.open 指令后回传 action 给插件
   */
  handleMessage(event: MessageEvent) {
    const { key, payload, windowId } = event.data || {};
    if (windowId && (windowId === this.windowId || windowId === "all")) {
      if (key === IframeToExtension.EXT_TO_IFRAME_KEY) {
        window.parent.postMessage(
          {
            key: IframeToExtension.IFRAME_TO_EXT_KEY,
            payload: { ...payload, url: window.location.href },
            windowId,
          },
          "*",
        );
      } else if (key === IframeToExtension.EXT_TO_IFRAME_NAVIGATE_TO_KEY) {
        this.navigateTo?.(payload.routerPath);
      } else if (key === IframeToExtension.EXT_TO_IFRAME_THEME_COMMON_KEY) {
        // this.commomHandlers?.themeChange?.(payload.theme);
        // const message = {
        //   key: ExtensionMethodsToIframe.EXT_TO_IFRAME_THEME_COMMON_KEY,
        //   payload: {...payload, action: payload.action, commonKey: "_POST_MESSAGE_COMMON_KEY_"},
        //   windowId: this.windowId,
        // };
        this.handCommonMessage(payload);
      }
    }
  }

  handCommonMessage(
    payload: {
      action: "theme_change" | "navigate_to";
      data: { theme?: "dark" | "light"; routerPath?: string };
    } & {
      commonKey: "_POST_MESSAGE_COMMON_KEY_";
    },
  ) {
    if (payload.commonKey === "_POST_MESSAGE_COMMON_KEY_") {
      if (payload.action === "theme_change") {
        const { theme } = payload?.data;
        if (theme === "dark" || theme === "light") {
          this.commomHandlers?.themeChange?.(theme);
        }
      } else if (payload.action === "navigate_to") {
        const { routerPath } = payload?.data;

        if (routerPath) {
          if (
            routerPath.includes("search/token") &&
            window.location.pathname.includes("chat")
          ) {
            // log.debug("routerPath contains search/token");

            try {
              // 创建 URL 对象解析路径
              const url = new URL(routerPath);
              // 分割路径
              const pathSegments = url.pathname.split("/");
              // 找到 token 后面的一个段
              const tokenIndex = pathSegments.findIndex(
                (segment) => segment === "token",
              );
              if (tokenIndex !== -1 && tokenIndex < pathSegments.length - 1) {
                const tokenSymbol = pathSegments[tokenIndex + 1]; // 获取到 "ETH"
                pubsub.emit(pubSubKeyMap.APPEND_CHAT_MESSAGE, {
                  symbol: tokenSymbol,
                });
                // 可以使用 tokenSymbol 进行后续处理
                // this.navigateTo?.(routerPath);
              } else {
                this.navigateTo?.(routerPath);
              }
            } catch (e) {
              this.navigateTo?.(routerPath);
            }
          } else {
            this.navigateTo?.(routerPath);
          }
        }
      }
    }
  }
}
